module.exports = __webpack_public_path__ + "75b7f5cfc74c78396f3e09fc99b9e9e8.svg";